import * as ActionTypes from "../actions/actionTypes";

const initialState = {
  username: null,
  loginerror: null,
  authenticated: false,
  loginform: {
    usernameValid: false,
    passwordValid: false,
    valid: false,
  },
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.USER_LOGIN_SUCCESS:
      state = {
        ...action.payload.user,
      };
      break;
    case ActionTypes.USER_LOGIN_FAILED:
      state = {
        ...state,
        authenticated: false,
        loginerror: action.payload.loginerror,
      };
      break;
    case ActionTypes.USER_LOGIN_FAILED_TOKEN_INVALID:
      state = {
        ...state,
        authenticated: false,
        loginerror: action.payload.loginerror,
      };
      break;
    case ActionTypes.USER_LOGIN_FAILED_TOKEN_EXPIRED:
      state = {
        ...state,
        authenticated: false,
        loginerror: action.payload.loginerror,
      };
      break;
    case ActionTypes.USER_LOGOUT_SUCCESS:
      state = {
        ...initialState,
      };
      break;
    case ActionTypes.USER_LOGINFORM_VALIDATE:
      state = {
        ...state,
        loginform: action.payload.loginform,
      };
      break;
    default:
      break;
  }
  return state;
};

export default userReducer;






// WEBPACK FOOTER //
// ./src/reducers/userReducer.js